import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";

let dev = "/tsg-admin";

const apis = {
  /*专家外审*/
  // v2.6.1 更换列表接口，接口参数auditStatus用于区分未完成审核和已完成审核
  expertauditList(data) {
    //审核列表
    // let url = "";
    // if (tab == 0) {
    //     url = "/sys/expertAudit/queryExpertauditList";
    // } else {
    //   url = "/sys/expertAudit/queryExpertauditListForFinish";
    // }
    return request({
      // v2.6.1 新专家外审
      url: dev + "/sys/expertAudit/auditArtPage",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  expertAudit(data) {
    //外审意见
    return request({
      url: dev + "/sys/expertAudit/expertAudit",
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  queryExpertAuditByAuditId(data) {
    //外审查看
    return request({
      url: dev + "/sys/expertAudit/queryExpertAuditByAuditId",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //   新专家外审
  // v2.6.1 /sys/expertAudit/selectInfo 专家审稿列表-期刊下拉列表
  queryExpertAuditPeriodical(data) {
    //外审查看
    return request({
      url: dev + "/sys/expertAudit/selectInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // /sys/expertAudit/getAuditInfo 外审专家审稿页面数据
  getExpertCustomOptions(data) {
    //外审查看
    return request({
      url: dev + "/sys/expertAudit/getAuditInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //  /sys/expertAudit/audit外审专家审核
  expertAuditOpinins(data) {
    //外审意见
    return request({
      url: dev + "/sys/expertAudit/audit",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // /sys/expertAudit/getAuditInfoList查看外审记录,
  getAuditInfoList(data) {
    //外审查看
    return request({
      url: dev + "/sys/expertAudit/getAuditInfoList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/expert.serve.js